import {Stack, type StackProps} from '@primer/react'
import {clsx} from 'clsx'
import type {ElementType} from 'react'

import itemContainerStyles from './ItemContainer.module.css'

type TrailingActionsProps = {
  children: React.ReactNode
  className?: string
  trailingActionStyling?: StackProps<ElementType>
}

// eslint-disable-next-line @eslint-react/no-unstable-default-props
export const TrailingActions = ({children, trailingActionStyling = {}, className}: TrailingActionsProps) => {
  const {direction, gap, ...rest} = trailingActionStyling
  return (
    <Stack
      className={clsx(itemContainerStyles.trailingActions, className)}
      direction={direction || 'horizontal'}
      gap={gap || 'condensed'}
      {...rest}
    >
      {children}
    </Stack>
  )
}
TrailingActions.displayName = 'TrailingActions'
